import SimpleTag from './SimpleTag';
import UserTag from './UserTag';

export { SimpleTag, UserTag };



// WEBPACK FOOTER //
// ./src/components/ui/Tags/index.js